import PaymentMethodAPI from './api'
import { objectToCamelCase, objectToSnakeCase } from '../utils'

export default class PaymentMethod {
  static api = PaymentMethodAPI.create(PaymentMethod)
  static readOnlyFields = ['id']
  constructor(paymentMethod) {
    const {
      id = '',
      object = null,
      brand = null,
      country = null,
      expMonth = null,
      expYear = null,
      funding = null,
      last4 = null,
    } = paymentMethod
    Object.assign(this, {
      id,
      object,
      brand,
      country,
      expMonth,
      expYear,
      funding,
      last4,
    })
  }

  static create(opts) {
    return new PaymentMethod(opts)
  }

  static fromAPI(json = {}) {
    return new PaymentMethod(objectToCamelCase(json))
  }

  /**
   * Prep data for the API. Can elect to include or exlude specific fields.
   * The readOnlyFields are always excluded.
   **/
  static toAPI(payment, fields = [], excludeFields = []) {
    // By default, send the whole object
    let data = {}

    // If it's a partial update, get only the fields specified
    if (fields.length > 0) {
      fields.forEach(field => {
        data[field] = payment[field]
      })
    } else {
      data = payment
    }

    excludeFields = [...PaymentMethod.readOnlyFields, ...excludeFields]
    excludeFields.forEach(item => {
      delete data[item]
    })

    return objectToSnakeCase(data)
  }

  /* Format payment method into readable display that mimics the API's payment_source_display. */
  formatPaymentMethod() {
    return `${this.formatCardType()} ${this.last4}`
  }
  /* Return card type ("Credit Card", "Debit Card") */
  formatCardType() {
    const capitalizedCardType = this.funding[0].toUpperCase() + this.funding.slice(1)
    return `${capitalizedCardType} Card`
  }
  formatExpiration() {
    const expYear = this.expYear.toString().slice(2, 4)
    return `${this.expMonth}/${expYear}`
  }
}
